<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="名称">
        <el-input placeholder="请输入升级包名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">查询</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="名称" prop="name" min-width="150"></el-table-column>
      <el-table-column label="版本" prop="version" width="280"></el-table-column>
      <el-table-column label="设备类型" prop="dev_type" width="120">
        <template slot-scope="{ row }">
          <span>{{ getDevTypeName(row.dev_type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="文件大小" prop="size" width="120">
        <template slot-scope="{ row }">
          <span>{{ formatFileSize(row.size) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="修改时间" prop="modify_time" width="180">
        <template slot-scope="{ row }">
          <span>{{ formatTime(row.modify_time) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="180">
        <template slot-scope="{ row }">
          <span>{{ formatTime(row.create_time) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
          <el-button type="text" @click="openRemoteUpgrade(row)" v-permision_tjtf="'upgrad'">设备升级</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增/修改升级包 -->
    <el-dialog :visible.sync="visible.editDialog" :title="isUpdate ? '编辑升级包' : '新增升级包'" width="600px">
      <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="packageForm">
        <el-form-item label="名称" prop="name">
          <el-input placeholder="请输入升级包名称" v-model="form.name" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-input placeholder="请输入版本号，如：1.0.0" v-model="form.version" maxlength="60" />
        </el-form-item>
        <el-form-item label="设备类型" prop="dev_type">
          <el-select v-model="form.dev_type" placeholder="请选择设备类型" style="width: 100%">
            <el-option v-for="item in devTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级文件" prop="package_url">
          <el-upload :action="UploadUpgradeFile" :name="'filedata'" :before-upload="beforeUpload" :on-success="handleUploadSuccess" :show-file-list="false" accept=".bin,.zip,.rar,.tar,.gz" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持 bin/zip/rar/tar.gz 格式，大小不超过 100MB</div>
          </el-upload>

          <!-- 自定义文件列表，展示已上传文件并提供下载/删除 -->
          <div v-if="fileList.length > 0" class="custom-file-list">
            <div v-for="(file, index) in fileList" :key="index" class="file-item">
              <i class="el-icon-document"></i>
              <span class="file-name">{{ file.name }}</span>
              <el-button type="text" icon="el-icon-download" @click="downloadPackageFile(file.url, file.name)">下载</el-button>
              <el-button type="text" icon="el-icon-delete" @click="handleRemoveFile">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="文件大小" prop="size">
          <el-input v-model="form.size" readonly disabled placeholder="上传文件后自动获取" />
        </el-form-item>
        <el-form-item label="加密串" prop="md5_str">
          <el-input placeholder="请输入加密串" v-model="form.md5_str" maxlength="32" show-word-limit />
        </el-form-item>
        <el-form-item label="说明" prop="remark">
          <el-input type="textarea" placeholder="请输入说明" v-model="form.remark" :rows="3" maxlength="500" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible.editDialog = false">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>

    <remote-upgrade-dialog ref="remoteUpgradeDialog"></remote-upgrade-dialog>
  </div>
</template>

<script>
import request from "@/utils/request"
import pageMixin from "@/mixins/pageMixin"
import { getUpgradePackagePageList, modifyUpgradePackage, delUpgradePackage, addUpgradePackage } from "@/api/dev_upgrade_package"
import { UploadUpgradeFile } from "@/api/public.js"
import RemoteUpgradeDialog from "./components/RemoteUpgradeDialog.vue"
export default {
  name: "UpgradePackage",
  mixins: [pageMixin],
  components: { UploadUpgradeFile, RemoteUpgradeDialog },

  data() {
    return {
      UploadUpgradeFile,
      visible: {
        editDialog: false
      },
      tableData: [],
      form: {
        name: "",
        version: "",
        dev_type: "",
        package_url: "",
        md5_str: "",
        remark: "",
        size: null
      },
      formRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        version: [{ required: true, message: "请输入版本", trigger: "blur" }],
        dev_type: [{ required: true, message: "请选择设备类型", trigger: "change" }],
        md5_str: [{ required: true, message: "请输入加密串", trigger: "blur" }]
      },
      filter: {
        name: ""
      },
      loading: false,
      isUpdate: false,
      currentId: "",
      fileList: [],
      uploadUrl: "/api/upload/file", // 修改为你的上传接口地址

      // 设备类型选项（根据实际情况调整）
      devTypeOptions: [
        { label: "充电桩", value: "power_charge_pile" },
        { label: "插座", value: "power_charge_cz" }
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 下载升级包文件
    // 直接使用绝对路径下载升级包文件
    downloadPackageFile(fileUrl, fileName) {
      if (!fileUrl) {
        this.$message.warning("文件地址不存在")
        return
      }
      // 创建隐藏的 <a> 标签并模拟点击，直接利用浏览器下载能力
      const link = document.createElement("a")
      link.href = fileUrl
      link.download = fileName || fileUrl.split("/").pop() // 未传文件名时从路径中提取
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 格式化文件大小显示
    formatFileSize(bytes) {
      if (!bytes) return "--"
      const units = ["B", "KB", "MB", "GB"]
      let size = bytes
      let unitIdx = 0
      while (size >= 1024 && unitIdx < units.length - 1) {
        size /= 1024
        unitIdx++
      }
      return `${size.toFixed(2)} ${units[unitIdx]}`
    },
    // 获取设备类型名称
    getDevTypeName(type) {
      const option = this.devTypeOptions.find((item) => item.value === type)
      return option ? option.label : type
    },
    // 打开远程升级弹窗
    openRemoteUpgrade(row) {
      this.$refs.remoteUpgradeDialog.showDialog(row)
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return ""
      return new Date(time).toLocaleString()
    },

    // 编辑升级包
    async onUpdate(row) {
      this.visible.editDialog = true
      this.isUpdate = true
      this.currentId = row.ID

      // 重置表单
      this.form = {
        name: row.name,
        version: row.version,
        dev_type: row.dev_type,
        package_url: row.package_url,
        md5_str: row.md5_str,
        remark: row.remark || "",
        size: row.size
      }
      if (row.package_url) {
        const fileName = row.package_url.split("/").pop()
        this.fileList = [{ name: fileName, url: row.package_url }]
      } else {
        this.fileList = []
      }
      // 设置文件列表
      // this.fileList = row.package_url
      //   ? [
      //       {
      //         name: row.package_url.split("/").pop(),
      //         url: row.package_url
      //       }
      //     ]
      //   : []
    },

    // 删除升级包
    onDelete(row) {
      this.$confirm("确定删除该升级包吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          delUpgradePackage({ ID: row.ID })
            .then((res) => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch((err) => {
              console.error("删除失败:", err)
              this.$message.error("删除失败")
            })
        })
        .catch(() => {})
    },

    // 获取表格数据
    getData() {
      this.loading = true
      getUpgradePackagePageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.name || null
      })
        .then((res) => {
          this.tableData = res.data || []
          this.pageParams.total = res.total || 0
        })
        .catch((err) => {
          console.error("获取升级包列表失败:", err)
          this.$message.error("获取数据失败")
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 新增升级包
    onAdd() {
      this.visible.editDialog = true
      this.isUpdate = false
      this.currentId = ""

      // 重置表单
      this.form = {
        name: "",
        version: "",
        dev_type: "",
        package_url: "",
        md5_str: "",
        remark: "",
        size: null
      }
      if (row.package_url) {
        const fileName = row.package_url.split("/").pop()
        this.fileList = [{ name: fileName, url: row.package_url }]
      } else {
        this.fileList = []
      }
    },

    // 文件上传成功
    handleUploadSuccess(res, file) {
      if (res.status === true) {
        // 替换文件列表（只保留最新上传的文件）
        this.fileList = [{ name: file.name, url: res.outputData.FilePath }]
        this.form.package_url = res.outputData.FilePath
        this.form.size = file.size
        this.form.md5_str = res.outputData.md5
        this.$message.success("文件上传成功")
      } else {
        this.$message.error(res.msg || "文件上传失败")
      }
    },

    // 文件上传前校验
    beforeUpload(file) {
      // 文件类型校验
      const isValid = /\.(bin|zip|rar|tar\.gz|tgz)$/i.test(file.name)
      if (!isValid) {
        this.$message.error("只支持 zip、rar、tar.gz 格式")
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error("文件大小不能超过 100MB")
        return false
      }
      // 如果已有文件，先清空再上传新文件（自动替换）
      if (this.fileList.length > 0) {
        this.handleRemoveFile()
      }
      return true
    },
    handleRemoveFile() {
      this.fileList = []
      this.form.package_url = ""
      this.form.size = null
    },
    // 文件移除
    handleUploadRemove() {
      this.form.package_url = ""
    },

    // 提交表单
    onSubmit() {
      this.$refs.packageForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            ...this.form
          }
          if (this.isUpdate) {
            reqData.ID = this.currentId
            modifyUpgradePackage(reqData)
              .then((res) => {
                this.$message.success("修改成功")
                this.visible.editDialog = false
                this.getData()
              })
              .catch((err) => {
                console.error("修改失败:", err)
                this.$message.error("修改失败")
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addUpgradePackage(reqData)
              .then((res) => {
                this.$message.success("新增成功")
                this.visible.editDialog = false
                this.getData()
              })
              .catch((err) => {
                console.error("新增失败:", err)
                this.$message.error("新增失败")
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },

    // 从 pageMixin 继承的方法
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },

    handleSizeChange(val) {
      this.pageParams.limit = val
      this.toFilter()
    },

    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.my-pagination {
  margin-top: 20px;
  text-align: right;
}

.table-header-cell {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.upload-demo {
  width: 100%;
}

.custom-file-list {
  margin-top: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px 12px;
  background-color: #f5f7fa;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-item i {
  color: #409eff;
}

.file-name {
  flex: 1;
  word-break: break-all;
}
</style>
